/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.role', ['popup', 'data.role']);
